export const plants = [
  {
    name: "METAX",
    areas: [
      {
        name: "Manufacture",
        units: [{ name: "Lathes" }, { name: "Milling Machines" }]
      }
    ]
  },
  {
    name: "Hidroprocesos",
    areas: [
      {
        name: "50",
        units: [
          { name: "14 Light Oil Hydrotreater" },
          { name: "15 Hydroprocessing Support Unit" },
          { name: "16 Gas Oil Hydrotreater" }
        ]
      }
    ]
  },
  {
    name: "Planta de Azufre",
    areas: [
      {
        name: "30",
        units: [
          { name: "24 Amine Regen Unit" },
          { name: "26 Sour Water Stripper" },
          { name: "28 Sulfur Recovery" },
          { name: "30 Tail Gas Unit" },
          { name: "32 Sulfur Prilling Unit" },
          { name: "64 Sulfur Loading" }
        ]
      }
    ]
  },
  {
    name: "Planta de Coker",
    areas: [
      {
        name: "20",
        units: [
          { name: "12 Delayed Coking" },
          { name: "18 Gas Unit" },
          { name: "45 Fuel Gas" }
        ]
      }
    ]
  },
  {
    name: "Planta de Crudo",
    areas: [
      {
        name: "05",
        units: [
          { name: "57 Flare System" },
          { name: "90 Raw Water Metering Station" }
        ]
      },
      {
        name: "10",
        units: [{ name: "10 Distilation" }]
      },
      {
        name: "90",
        units: [{ name: "51 Flush" }, { name: "61 Tank Farm" }]
      }
    ]
  },
  {
    name: "Servicios Industriales",
    areas: [
      {
        name: "40",
        units: [
          { name: "62 Solid Removal Facilities" },
          { name: "63 Slop Oil" },
          { name: "65 Waste Water Treatment" },
          { name: "67 Fire Water Pumps" }
        ]
      },
      {
        name: "60",
        units: [{ name: "22 Hydrogen Production" }]
      },
      {
        name: "70",
        units: [
          { name: "41 Steam Generator" },
          { name: "42 Reverse Osmosis System" },
          { name: "43 BFW & COND Recovery" },
          { name: "44 Service Water Storage" },
          { name: "46 Plant And Instr Air System" },
          { name: "47 Cooling Tower" },
          { name: "48 Inert Gas" }
        ]
      }
    ]
  }
];
